<script lang="ts">
import type { ButtonProps } from '#ui/types';
import type { RouteLocationAsRelativeGeneric } from '#vue-router';

import { FE_PAGE_PARAM, FIRST_PAGE } from '~/constants/pagination';

const propsDefinition = {
    page: {
        type: Number,
        required: true,
    },
    itemsPerPage: {
        type: Number,
        required: true,
    },
    total: {
        type: Number,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String as PropType<ButtonProps['size']>,
        default: undefined,
    },
} as const;

// PROPS
export type BasePaginationProps = ExtractPropTypes<typeof propsDefinition>;
</script>
<script setup lang="ts">
const { page, itemsPerPage, total } = defineProps(propsDefinition);

// COMPOSABLES
const route = useRoute();

// METHODS
const formatRoute = (p: number): RouteLocationAsRelativeGeneric => ({
    query: { ...route.query, [FE_PAGE_PARAM]: p !== FIRST_PAGE ? p : undefined },
});

const onPageChange = (): void => scrollToTop();
</script>

<template>
    <UPagination
        :default-page="page"
        :items-per-page="itemsPerPage"
        :total="total"
        show-edges
        :size="size"
        :disabled="disabled"
        :to="formatRoute"
        variant="ghost"
        @update:page="onPageChange"
    >
        <template #first>
            <span />
        </template>
        <template #last>
            <span />
        </template>
    </UPagination>
</template>
